import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import posed, { PoseGroup } from 'react-pose'

import Arrow from './Arrow'
import Featured from './Featured'

const PosedWrapper = posed.div({
  enter: {
    y: 0,
  },

  exit: {
    y: 0,
  },
})

const PosedText = posed.h2({
  enter: {
    opacity: 1,
    y: '0',
    delay: 1000,
    transition: {
      y: { type: 'spring', stiffness: 100, damping: 10 },
    }
  },

  exit: {
    opacity: 0,
    y: '25%'
  }
})

const PosedSellingPoint = posed.span({
  enter: {
    y: 0,
    delay: ({ i }) => i * 150 + 1500,
    transition: {
      y: { type: 'spring', stiffness: 80, damping: 10 },
    }
  },

  exit: {
    y: '100%',
    delay: 0
  },
})

const HeroContainer = styled.div`
  overflow-x: hidden;
  margin-bottom: 60px;
`

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  background: url(${props => props.image}) center / cover;
`

const Content = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  height: 100%;
`

const Title = styled.h1`
  font-family: ${props => props.theme.displayFont};
  font-weight: 900;
  font-size: 40px;
  line-height: 40px;
  color: ${props => props.theme.colors.grey.lightest};
  text-transform: uppercase;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-color: ${props => props.theme.colors.grey.lightest};
  -webkit-text-stroke-width: 1px;

  ${media.md`
    -webkit-text-stroke-width: 2px;
    font-size: 60px;
    line-height: 60px;
  `}

  ${media.lg`
    font-size: 75px;
    line-height: 75px;
  `}

  ${media.xl`
    font-size: 100px;
    line-height: 100px;
  `}
`

const Text = styled(PosedText)`
  font-size: 40px;
  line-height: 40px;
  font-family: ${props => props.theme.displayFont};
  font-weight: 900;
  color: ${props => props.theme.colors.grey.lightest};
  text-transform: uppercase;
  margin: 0;
  text-align: center;
  opacity: 0;

  ${media.md`
    font-size: 60px;
    line-height: 60px;
  `}

  ${media.lg`
    font-size: 75px;
    line-height: 75px;
  `}

  ${media.xl`
    font-size: 100px;
    line-height: 100px;
  `}
`

const AnimContainer = styled(PosedWrapper)`
  overflow: hidden;
  padding-top: 1em;
  margin-top: -1em;
`

const AnimText = styled(PosedSellingPoint)`
  display: block;
`

const ImageOverlay = styled.div`
  background: ${props => props.theme.colors.oxford.dark};
  height: 100%;
  left: 0;
  opacity: 0.3;
  position: absolute;
  top: 0;
  width: 100%;
`

export default class Hero extends Component {
  render() {
    const {
      sellingPoints,
      cta,
      image,
      firstFeaturedImage,
      firstFeaturedText,
      firstFeaturedLink,
      secondFeaturedImage,
      secondFeaturedText,
      secondFeaturedLink,
    } = this.props

    return(
      <HeroContainer>
        <Wrapper image={image.sourceUrl}>
          <Content>
            <Container fluid>
              <Row>
                <Col smOffset={2} sm={8}>
                  {cta &&
                    <Text pose="enter" initialPose="exit">{cta}</Text>
                  }
                </Col>
              </Row>
              <Row>
                <Col smOffset={2} sm={8}>
                  <Title>
                    <PoseGroup withParent={false} animateOnMount={true}>
                      {sellingPoints && sellingPoints.map((point, index) => {
                        return(
                          <AnimContainer
                            key={Math.random()}
                            i={index}
                          >
                            <AnimText
                              key={Math.random()}
                              i={index}
                            >
                              {point.sellingPoint}&nbsp;
                            </AnimText>
                          </AnimContainer>
                        )
                      })}
                    </PoseGroup>
                  </Title>
                </Col>
              </Row>

            </Container>
          </Content>

          <Arrow />
          
          <ImageOverlay />
        
        </Wrapper>
        
        <Container fluid>
          <Row>
            {firstFeaturedImage &&
              <Col
                sm={5}
                smOffset={1}
              >
                <Featured
                  image={firstFeaturedImage.sourceUrl}
                  text={firstFeaturedText}
                  link={firstFeaturedLink}
                />
              </Col>
            }

            {secondFeaturedImage &&
              <Col
                sm={5}
                smOffset={1}
              >
                <Featured
                  image={secondFeaturedImage.sourceUrl}
                  text={secondFeaturedText}
                  link={secondFeaturedLink}
                  noMobileMargin
                />
              </Col>
            }
          
          </Row>
        </Container>
      
      </HeroContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Hero/index.js